/**
 * BIGSIGNS — brand text cleanup
 *
 * Displays "BigSigns.com" / "BigSigns.com's" in visible page text as
 * "BigSigns" / "BigSigns's". Only text nodes are touched — links (href),
 * emails, <script> (incl. JSON-LD schema) and form fields are left as-is.
 * Text that is itself a URL or email (www.bigsigns.com, info@bigsigns.com,
 * bigsigns.com/pages/...) is skipped.
 */
(function () {
  if (window.__bigsignsBrandText) return;
  window.__bigsignsBrandText = true;

  var BRAND_RE = /(^|[^A-Za-z0-9.@\/_\\:-])(bigsigns)\.com(?![A-Za-z0-9\/_-])/gi;
  var TEST_RE = /bigsigns\.com/i;
  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, INPUT: 1, SELECT: 1, OPTION: 1, CODE: 1, PRE: 1 };

  function fixTextNode(node) {
    var text = node.nodeValue;
    if (!text || !TEST_RE.test(text)) return;
    var parent = node.parentNode;
    if (!parent || SKIP_TAGS[parent.nodeName] || parent.isContentEditable) return;
    var updated = text.replace(BRAND_RE, '$1BIGSIGNS');
    if (updated !== text) node.nodeValue = updated;
  }

  function walk(root) {
    if (!root) return;
    if (root.nodeType === 3) return fixTextNode(root);
    if (root.nodeType !== 1 || SKIP_TAGS[root.nodeName]) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) fixTextNode(node);
  }

  function init() {
    walk(document.body);

    // Content added later (cart drawer, quick view, AJAX sections, etc.)
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'characterData') {
          fixTextNode(m.target);
        } else {
          for (var j = 0; j < m.addedNodes.length; j++) walk(m.addedNodes[j]);
        }
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
